import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function DollarT({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>DollarT</title>
      <path
        d="M13.1667 8.41667L12.8159 8.14105C12.2873 7.72575 11.6346 7.5 10.9624 7.5H6.75C5.23122 7.5 4 8.73122 4 10.25V10.25C4 11.7688 5.23122 13 6.75 13H11.25C12.7688 13 14 14.2312 14 15.75V15.75C14 17.2688 12.7688 18.5 11.25 18.5H6.16695C5.41638 18.5 4.69307 18.2186 4.13978 17.7115L4 17.5833"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 20L9 6"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5385 6V10.5C17.5385 11.3284 18.3134 12 19.2692 12C20.2251 12 21 11.3284 21 10.5M17.5385 6L16 7.33333M17.5385 6L19.0769 7.33333"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
